import { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import { useSupplierByProductQuery } from "../../../services/supplierApi";
import { signInUser } from "../../Utility/Auth";
// import customStyles from "./SelectFeild";

const SupplierSelectByProduct = ({
  article_code,
  handleOnChange,
  name,
  value,
}) => {
  const auth = signInUser();
  const { aamarId } = auth;
  // console.log("articleCode:", article_code);
  let [supplier, setSupplier] = useState([]);
  const supplierList = useSupplierByProductQuery({ article_code, aamarId });

  console.log(supplierList);
  //   const id = "5410235"
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#0d6efd" // Background color on hover
        : state.isSelected
        ? "#fff" // Background color when selected (red)
        : "transparent", // Default background color
      color: state.isFocused
        ? "#fff" // White text color on hover
        : state.isSelected
        ? "#000" // White text color when selected
        : "#000", // Default black text color
      padding: "10px 15px", // Padding for better spacing

      transition: "background-color 0.2s ease, color 0.2s ease", // Smooth transition for background and text color
    }),
    control: (provided) => ({
      ...provided,

      // Optional: Customize the input control here
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px", // Rounded corners for the dropdown menu
      color: "#000", // Black text color

      // High z-index to ensure it appears above other elements
      // Ensure proper stacking context
    }),
  };

  useEffect(() => {
    let vendors = [];
    if (supplierList.data) {
      supplierList.data?.map((vendor) => {
        let item = vendor.products.find((v) => v.article_code === article_code);
        // item?.map(v => {
        // console.log("items:", item);
        vendors = [
          ...vendors,
          {
            option: vendor._id,
            label: `${vendor?.company} - ${vendor.name}`,
          },
        ];

        // })
        // console.log(vendor);
      });
      // supplierList.data.map((vendor) => {
      //   // if (item) {
      // console.log(supplierList.data.length);
    }
    // });
    // console.log(vendors);
    setSupplier(vendors);
  }, [supplierList.data]);

  // console.log("vendor:", supplier);
  // console.log("vendorList:", supplierList.data);
  // console.log(supplier[supplier.map((obj) => obj.option).indexOf(value[0].id))
  // console.log(supplier[0]);
  return (
    <Fragment>
      <Select
        styles={customStyles}
        className="basic-single"
        classNamePrefix="select"
        defaultValue={supplier[0]}
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isSearchable={true}
        onChange={(e) => handleOnChange(name, e)}
        name={name}
        options={supplier}
        value={
          value && supplier[supplier.map((obj) => obj.option).indexOf(value)]
        }
      />
    </Fragment>
  );
};

export default SupplierSelectByProduct;
